<template>
	<LoginForm />
</template>

<script>
import { useMeta } from 'vue-meta';
import { useI18n } from 'vue-i18n/index';
import LoginForm from '@/components/auth/forms/LoginForm.vue';

export default {
	name: 'Login',
	components: {
		LoginForm
	},
	setup () {
		const { t } = useI18n();
		useMeta({ title: t('pages.auth.login.pageTitle', { appName: 'Clarity' }) });
	}
};
</script>
